module.exports = __webpack_public_path__ + "img/0050.cc70329c.jpg";